import {
  LinearProgress as MuiLinearProgress,
  linearProgressClasses,
  styled,
} from "@mui/material";

export const LinearProgress = styled(MuiLinearProgress)(({ theme }) => ({
  h: 2,
  borderRadius: 12,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.newColors.neutral.gray100,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 12,
    backgroundColor: theme.newColors.theme.primary,
  },
}));
